import { render, staticRenderFns } from "./ColPack.vue?vue&type=template&id=2f6425b3&scoped=true"
import script from "./ColPack.vue?vue&type=script&lang=js"
export * from "./ColPack.vue?vue&type=script&lang=js"
import style0 from "./ColPack.vue?vue&type=style&index=0&id=2f6425b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6425b3",
  null
  
)

export default component.exports